const newsletter = `
# eBL Newsletter 8

## 9 June 2022

### Corpus & Fragmentarium

#### Display mode

- Notes are now displayed in Corpus and Fragmentarium.
- Lemmatization is now displayed.
- Links to CCP / SAAo are implemented in Fragmentarium editions. It is possible
  to implement links to editions in other ORACC projects.

#### Search

- Display mode in search (for Fragmentarium editions).
- Bibliography and Genre are displayed (for Fragmentarium editions).
- Search with pagination: the number of results is no longer limited.
- Search is now inclusive, e.g. one can search for signs within one tablet.

### Corpus

#### Display

- Variant words are now marked in Corpus editions.

### Website launch

- We strive to open [http://www.ebl.lmu.de](http://www.ebl.lmu.de) to the public
  in Autumn 2022.`

export default newsletter
